// Last path segment of the storage key, with the type appended when the key has no extension.
export const getCvFileName = (cvS3Key: string, fileType?: string) => {
  const baseName = cvS3Key.split('/').pop() ?? '';

  if (!fileType || baseName.toLowerCase().endsWith(`.${fileType}`)) {
    return baseName;
  }

  return `${baseName}.${fileType}`;
};
